import { Input, message, Tag } from "antd";
import TextArea from "antd/es/input/TextArea";
import { resize } from "framer-motion";
import { MoveLeft, Plus } from "lucide-react";
import React, { useState } from "react";
import { downloadCSV } from "../../../CsvTemplate";
import BatchCsvUpload from "../../../BatchCsvUpload";
import { createBatch } from "../../../../api/globalAdmin/Index";
import WebUtils from "../../../../utils/WebUtils";

function CreateBatch({
  setCreateBatchFlag,
  userDetail,
  setLoading,
  setCreatedSuccessFlag,
}) {
  const [form, setForm] = useState({
    batchName: "",
    tags: [],
    description: "",
  });
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [open, setOpen] = useState(false);

  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleAddTag = () => {
    const value = inputValue.trim();

    if (value && !form.tags.includes(value)) {
      handleChange("tags", [...form.tags, value]);
    }

    setInputValue("");
    setShowInput(false);
  };

  const handleClose = (removedTag) => {
    handleChange(
      "tags",
      form.tags.filter((tag) => tag !== removedTag),
    );
  };

  const createNew = async (data) => {
    if (!data && !form.batchName) {
      message.error("Batch name required!");
      return;
    }
    const url = `${createBatch}`;

    let req = {
      batchInfoList: data ? data : [form],
      userId: userDetail?.userIdentifier,
      organizationId: userDetail.organizationId,
    };
    // console.log(req);

    setLoading(true);

    WebUtils.httpOperations(url, req, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          console.log(result.data);
          // setOpen(false);
          // setCreateBatchFlag(true);

          setOpen(false);
          setTimeout(() => {
            setCreatedSuccessFlag(true);
          }, 200);
        } else {
          //   setJdDetails(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const users = [
    {
      batchName: "CSE Final Year A",
      tag1: "2026 Batch",
      tag2: "Final Year",
      tag3: "Section A",
      tag4: "Placement Cell",
      tag5: "Morning Shift",
      tag6: "Campus Drive",
      description:
        "Final year Computer Science students preparing for campus placements and project submissions.",
    },
  ];

  const customCsvData = users.map((item, index) => ({
    "Batch ID": index + 1,
    "Batch Name": item.batchName,
    "Tag 1": item.tag1,
    "Tag 2": item.tag2,
    "Tag 3": item.tag3,
    "Tag 4": item.tag4,
    "Tag 5": item.tag5,
    "Tag 6": item.tag6,
    Description: item.description,
  }));

  return (
    <div className="max-w-[600px] mx-auto mt-4">
      <p className="header-text text-center">Create Batch</p>

      <div className="mt-4 ">
        <p className="sub-text-color text-[.85rem] font-semibold">
          Batch name <span className="text-red-500">*</span>
        </p>
        <Input
          className="mt-1"
          value={form?.name}
          placeholder="Enter batch name..."
          onChange={(e) => handleChange("batchName", e.target.value)}
          size="large"
        />
      </div>
      <div className="mt-4">
        <p className="sub-text-color text-[.85rem] font-semibold">
          Tags{" "}
          <span className="text-gray-300 font-semibold text-[.85rem]">
            (max. 6 tags allowed)
          </span>{" "}
        </p>
        <div className="w-full rounded-lg border border-gray-300 p-2 bg-white mt-1">
          <div className="flex flex-wrap items-center gap-x-1 gap-y-1">
            {form?.tags.map((tag) => (
              <Tag
                key={tag}
                closable
                onClose={() => handleClose(tag)}
                className="!px-2 !py-[2px] !rounded-lg !border-blue-200 !bg-blue-50 !text-blue-700"
              >
                {tag}
              </Tag>
            ))}

            {showInput ? (
              <Input
                autoFocus
                size="small"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onBlur={handleAddTag}
                onPressEnter={handleAddTag}
                placeholder="Enter tag"
                className="!w-32 !rounded-md"
              />
            ) : (
              form.tags?.length < 6 && (
                <button
                  onClick={() => setShowInput(true)}
                  className="flex items-center gap-1 rounded-lg border border-dashed border-gray-400 px-2 py-[2px] text-sm text-gray-600 hover:border-blue-500 hover:text-blue-500 transition"
                >
                  <Plus size={14} />
                  Add
                </button>
              )
            )}
          </div>
        </div>
      </div>
      <div className="mt-4">
        <p className="sub-text-color text-[.85rem] font-semibold">
          Description
        </p>
        <TextArea
          className="mt-1 rounded-lg"
          value={form?.description}
          style={{ height: 120, resize: "none" }}
          placeholder="Type here..."
          onChange={(e) => handleChange("description", e.target.value)}
        />
      </div>
      <div className="mt-4 sub-text-color text-[.9rem]">
        Want to create multiple batches at once?{" "}
        <span
          onClick={() => downloadCSV(customCsvData, "users.csv")}
          className="text-[#DC6803] border-b-[1px] border-[#DC6803] cursor-pointer pb-[1px] font-semibold hover:brightness-110 transition-all duration-200 ease-in-out"
        >
          Download the CSV template
        </span>
        , fill in the required details, and{" "}
        <BatchCsvUpload createNew={createNew} open={open} setOpen={setOpen}>
          <span className="text-[#DC6803] border-b-[1px] border-[#DC6803] cursor-pointer pb-[1px] font-semibold hover:brightness-110 transition-all duration-200 ease-in-out">
            Click to upload the file
          </span>
        </BatchCsvUpload>{" "}
        here.
      </div>
      <div className="mt-4 flex justify-between">
        <button
          onClick={() => setCreateBatchFlag(false)}
          className="flex gap-2 items-center text-[.875rem] hover:text-amber-500 transition-all duration-200"
        >
          <MoveLeft size={16} /> Go back
        </button>
        <button
          onClick={() => createNew()}
          className="btn-orange px-4 py-[5px] rounded-lg text-[.9rem]"
        >
          Create Batch
        </button>
      </div>
    </div>
  );
}

export default CreateBatch;
